import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'bf-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'BMH Care Anywhere',
  fillColor: '',
  welcomeText: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 1, // ToDo
  email: '@', // ToDo
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/bf/index.js